import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const Services = () => {
  const services = [
    {
      icon: 'fas fa-laptop-code',
      title: 'Website Development',
      description:
        'Create modern, responsive, and high-performance websites tailored to your business needs. From landing pages to complex web applications, delivering pixel-perfect solutions with cutting-edge technologies.',
    },
    {
      icon: 'fas fa-code',
      title: 'Backend Development',
      description:
        'Build robust, scalable backend systems using Java, Spring Boot, and microservices architecture. From REST APIs to complex business logic, I deliver production-ready solutions.',
    },
    {
      icon: 'fas fa-project-diagram',
      title: 'System Design & Architecture',
      description:
        'Design and architect scalable systems that handle growth and complexity. Expert in microservices, distributed systems, and cloud-native architectures.',
    },
    {
      icon: 'fas fa-database',
      title: 'Database Design & Optimization',
      description:
        'Design efficient database schemas, optimize queries, and implement caching strategies. Experience with SQL, NoSQL, and data modeling best practices.',
    },
    {
      icon: 'fas fa-mobile-alt',
      title: 'API Development',
      description:
        'Create well-documented, secure, and performant REST APIs. Design API contracts, implement authentication, and ensure seamless integration.',
    },
    {
      icon: 'fas fa-cloud',
      title: 'Cloud & DevOps',
      description:
        'Deploy and manage applications on AWS, implement CI/CD pipelines, containerization with Docker, and orchestration with Kubernetes.',
    },
  ];

  return (
    <section id="services" className="py-5">
      <Container>
        <Row className="justify-content-center">
          <Col lg={10}>
            <h2 className="section-title text-center">Services I Offer</h2>
            <p className="section-subtitle text-center">
              Comprehensive software engineering services tailored to your needs
            </p>
          </Col>
        </Row>
        <Row className="mt-4">
          {services.map((service, idx) => (
            <Col lg={4} md={6} key={idx} className="mb-4">
              <Card className="text-center p-3">
                <Card.Body>
                  <div
                    className="mb-3"
                    style={{
                      fontSize: '3rem',
                      color: '#2563eb',
                    }}
                  >
                    <i className={service.icon}></i>
                  </div>
                  <Card.Title className="fw-bold mb-3">{service.title}</Card.Title>
                  <Card.Text className="text-muted">{service.description}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Services;